import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import UnpairedProductAssignToExistingForm from './UnpairedProductAssignToExistingForm';
import * as actions from './store/unpairedProductActions';
import * as Yup from "yup";
import { hasPermission, parseURL } from '../../sc-utilities';
import History from "../../../History";

const styles = theme => ({
    root: {},
    progressBarr: {},
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const UnpairedProductsAssignToExisting = props => {
    let { activeCustomerID, onAssignExternalID, translations, permissions, creating } = props;

    const handleSubmit = async formData => {
        let result = await onAssignExternalID({ ...formData, ActiveCustomerID: activeCustomerID, ProductExternalInfoID: parseURL(window.location.href).ProductExternalInfoID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {};
    let formSettings = {
        Validation: {
            ExternalID: Yup.string().required("Required")
        },
        FormTitle: translations["assign_product_to"] || "Assign product to an external data",
        ButtonSubmit: hasPermission(permissions, "unpaired_product_force_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <UnpairedProductAssignToExistingForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            translations={translations}
            loading={creating}
        />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        creating: state.product.unpairedProducts.creating
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAssignExternalID: data => dispatch(actions.assignExternalID(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(UnpairedProductsAssignToExisting));